import { render, staticRenderFns } from "./model_edit.vue?vue&type=template&id=0e91e36e&scoped=true"
import script from "./model_edit.vue?vue&type=script&lang=ts"
export * from "./model_edit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e91e36e",
  null
  
)

export default component.exports